import { type ComponentProps } from 'react';

export default function HardwareIcon ({ ...otherProps }: ComponentProps<'svg'>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512' fill='currentColor' {...otherProps}>
      <path d='m353.1 0H94.2L0 258.9h0s0 0 0 0l166.5 248.8h258.9l94.2-258.9L353.1 0zM112.4 26h212.8s-78.4 215.7-78.4 215.7H33.8L112.4 26z' />
    </svg>
  );
}
